<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title">
</app-common-page-breadcrumbs>
<div *ngIf="enableLoader" id="loader"></div>
<div >
  <div class="container d-flex justify-content-center py-4" *ngIf="masterDataModel">
    <div class="" *ngIf="!enableLoader">
      <ng-container>
        <form  class="" [formGroup]="addcontactform">
          <div class="form-row">
            <div class="form-group mt-3 col-md-2">
              <label for="Salutation">{{'heading.Salutation' | cxTranslate}}</label>
              <select id="Salutation" class="form-control form-control-lg input pl-1" formControlName="titleCode"
                >
                <option class="input" *ngFor="let sal of masterDataModel.titles" value="{{sal.code}}">{{sal.name}}
                </option>
              </select>
            </div>
            <div class="form-group mt-3 col-md-5">
              <label for="Firstname">{{'heading.Firstname' | cxTranslate}}</label>
              <input type="text" class="form-control form-control-lg input" id="Firstname" formControlName="firstName" maxlength="40">
              <p *ngIf="addcontactform?.controls.firstName.errors?.required && addcontactform?.controls.firstName.dirty"
                class="text-danger f-14">{{'home.validation.Field' | cxTranslate}} </p>
              <p *ngIf="addcontactform?.controls.firstName.errors?.pattern && addcontactform?.controls.firstName.dirty"
                class="text-danger f-14"> {{'home.validation.special' | cxTranslate}}</p>
            </div>
            <div class="form-group mt-3 col-md-5">
              <label for="Lastname">{{'heading.Lastname' | cxTranslate}}</label>
              <input type="text" class="form-control form-control-lg input" id="Lastname" formControlName="lastName" maxlength="40">
              <p *ngIf="addcontactform?.controls.lastName.errors?.required && addcontactform?.controls.lastName.dirty"
                class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
              <p *ngIf="addcontactform?.controls.lastName.errors?.pattern && addcontactform?.controls.lastName.dirty"
                class="text-danger f-14"> {{'home.validation.special' | cxTranslate}}</p>
            </div>
          </div>
          <div class="form-group mt-3 mb-3">
            <label for="Email">{{'heading.E-mail*' | cxTranslate}}</label>
            <input type="email" class="form-control form-control-lg input" id="Email" formControlName="email" >
            <p *ngIf="addcontactform?.controls.email.errors?.required && addcontactform?.controls.email.dirty"
              class="text-danger f-14">{{'home.validation.Field' | cxTranslate}}</p>
            <p *ngIf="addcontactform?.controls.email.errors?.pattern && addcontactform?.controls.email.dirty"
              class="text-danger f-14"> {{'home.validation.email' | cxTranslate}}</p>
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="Mobile"> {{'heading.Mobile' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="Mobile" formControlName="mobileNumber" maxlength="40">
            <p *ngIf="addcontactform?.controls.mobileNumber.errors?.pattern && addcontactform?.controls.mobileNumber.dirty"
              class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="AlternateNumber"> {{'heading.AlternateNumber' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="alternateNumber" formControlName="alternateNumber" maxlength="40">
            <p *ngIf="addcontactform?.controls.alternateNumber.errors?.pattern && addcontactform?.controls.alternateNumber.dirty"
              class="text-danger f-14">{{'home.validation.mobile' | cxTranslate}}</p>
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="jobTitle"> {{'heading.Designatedcontact' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="jobTitle" formControlName="jobTitle" maxlength="40">
          </div>
          <div class="form-group mt-4 mb-3">
            <label for="Department"> {{'heading.Department' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="department" formControlName="department" maxlength="80">
          </div>
          <!-- <div class="form-group mt-4 mb-3">
            <label for="personalLinked"> {{'heading.personalLinked' | cxTranslate}}</label>
            <input type="text" class="form-control form-control-lg input" id="personalLinked" formControlName="linkedInProfile" maxlength="255">
          </div> -->
          <label> {{'heading.Role' | cxTranslate}}</label>
          <ng-select [items]="masterDataModel.userRole" [multiple]="true" id="userRole" formControlName="userRole" [clearable]="false" bindLabel="description" dropdownPosition="bottom" groupBy="code"
          placeholder="{{ 'heading.SelectRole' | cxTranslate }}" [selectableGroup]="false"
          [closeOnSelect]="true" bindValue="code" [(ngModel)]="userRoles" [ngModelOptions]="{standalone: true}"
          notFoundText="{{'heading.NoItemsFound' | cxTranslate }}" >
          <ng-template ng-multi-label-tmp>
            <span class="filter-count pl-2 text-black">{{userRoles.length}}x {{ 'heading.SelectedRoles' | cxTranslate }}</span>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
            class="dropdown-ng-template">
            <input type="checkbox" /> 
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          
            <input (click)="selectUserRole(item, item$.selected)" id="{{item.code}}" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" [checked]="item.checked"  type="checkbox"
               /> <span>{{item.description}}</span>
            
          </ng-template>
        </ng-select>
          <label class="mt-4"> {{'heading.Commodity' | cxTranslate}}</label>
          <!-- <ng-multiselect-dropdown id="materials" formControlName="commodityType" [ngValue]="selectedCommodity"
            [placeholder]=" " [settings]="dropdownSettings" [data]="masterDataModel.commodityType"
            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">

          </ng-multiselect-dropdown> -->
            <ng-select [items]="masterDataModel.commodityType" [multiple]="true" id="commodityType" formControlName="commodityType" [clearable]="false" bindLabel="description" dropdownPosition="bottom" groupBy="id"
           placeholder="{{ 'heading.SelectCommodity' | cxTranslate }}" [selectableGroup]="false"
           [closeOnSelect]="true" bindValue="id" [(ngModel)]="commodityTypes" [ngModelOptions]="{standalone: true}"
           notFoundText="{{'heading.NoItemsFound' | cxTranslate }}" >
           <ng-template ng-multi-label-tmp>
             <span class="filter-count pl-2 text-black">{{commodityTypes.length}}x {{ 'heading.SelectedTypestypes' | cxTranslate }}</span>
           </ng-template>
           <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
             class="dropdown-ng-template">
             <input type="checkbox" /> 
           </ng-template>
           <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
           
             <input (click)="selectCommodity(item, item$.selected)" id="{{item.id}}" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" [checked]="item.checked"  type="checkbox"
                /> <span>{{item.description}}</span>
             
           </ng-template>
         </ng-select>
        
          <hr>
          <h5 class="strong"> {{'heading.ShoppingDetails' | cxTranslate}}</h5>
          <div class="form-check" *ngFor="let mod of masterDataModel.modeOfContacts;let i = index">
            <input class="form-check-input input text-dark" type="radio" id="mot{{i}}" name="modeOfContact"
              formControlName="modeOfContact" value="{{mod.id}}"  >
            <label class="form-check-label input text-dark" for="mot{{i}}">
              {{mod.name}}
            </label>
          </div>
          <hr>
          <h5 class="strong" >{{'heading.BhpConnect' | cxTranslate}}</h5>
          <div class="form-check" >
            <input class="form-check-input bg-white input text-dark" value="true" type="radio" id="AI0" name="accessIndicator"
              formControlName="accessIndicator" >
            <label for="AI0" class="form-check-label input text-dark" >
              {{'heading.yes' | cxTranslate}}
            </label>
            </div>
            <div class="form-check">
            <input class="form-check-input bg-white input text-dark" value="false" type="radio" id="AI1" name="accessIndicator"
            formControlName="accessIndicator" >
           <label for="AI1" class="form-check-label input text-dark">
            {{'heading.no' | cxTranslate}}
          </label>
        </div>
          
          
          <div class="form-group mt-5 mb-3">
            <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="createcontact(addcontactform?.value)"
            [disabled]="!admin|| isDisabled|| !addcontactform?.valid || isSaveDisabled" *ngIf="admin">
              {{'heading.Save' | cxTranslate}}
            </button>
            <button class="btn btn-block btn-secondary btn-lg" type="submit"
               (click)="navigateToLandingPage()"
              [disabled]="!admin || isSaveDisabled" *ngIf="admin">
              {{'heading.Cancel' | cxTranslate}}
            </button>
            <button class="btn btn-block btn-secondary btn-lg" [routerLink]="{ cxRoute : 'contacts' } | cxUrl"
               (click)="sendMessage()"
              *ngIf="!admin">
              {{'heading.Back' | cxTranslate}}
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
